<template>
    <div class="CMasonryBannerCard">
        <div class="banner-content rounded-xl bg-gray-900 dark:bg-surface-card p-6 shadow-md h-full flex flex-col">
            <h2 class="mb-3 text-xl font-bold text-white">
                Pomôž iným rásť
            </h2>
            <p class="mb-4 text-sm leading-relaxed text-gray-300 dark:text-txt-body">
                Ako mentor/ka odovzdáš svoje skúsenosti iným a zároveň získaš nové inšpirácie.
            </p>
            <CTAButtonWithLogin
                class="w-full rounded-lg bg-primary-500 hover:bg-primary-600 px-4 py-2.5 text-center text-sm font-semibold text-white transition-all mt-auto"
                :has-published-mentor="hasPublishedMentorProfile"
                :to="{ name: 'profile-mentoring' }"
                @click="trackCTAButtonWithLogin()"
            >
                {{ hasPublishedMentorProfile ? 'Môj mentoring' : 'Stať sa mentorom' }}
            </CTAButtonWithLogin>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useApplicationStore } from '@/stores/application'
import { useExponea } from '@/composables/exponea/useExponea'
import { VisibilityType } from '#shared/types/visibility'

const applicationStore = useApplicationStore()
const { trackExponeaEvent } = useExponea()

const hasPublishedMentorProfile = computed(() => {
    return applicationStore.userProfile?.mentorProfile?.visibility === VisibilityType.published
})

const mentorSlug = computed(() => {
    return applicationStore.userProfile?.slug
})

function trackCTAButtonWithLogin() {
    trackExponeaEvent({
        eventName: 'cta1_klik_stansa_mentorom',
        userId: applicationStore.userId,
        eventProperties: {
            button_text: hasPublishedMentorProfile.value ? 'Upraviť mentorský profil' : 'Staň sa mentorom',
            source: 'mentor_listing_inline'
        }
    })
}
</script>

<style scoped>
.CMasonryBannerCard {
    border-radius: 5px;
    opacity: 100%;
    background-color: transparent;
    width: 100%;
    min-width: 12.5rem;
    min-height: 280px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.banner-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>